/* eslint-disable react-hooks/exhaustive-deps */

import { Box, ThemeProvider, createTheme } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import React, { useEffect, useState } from 'react';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { getSurveyQuestions, setSurveyLoadingComplete, setQuestionId } from '../surveys.actions';
import { GET_SURVEY_QUESTIONS_FAILURE } from '../surveys.types';
import SurveyQuestionDetails from './surveyQuestionDetailsView.component';
import { fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { showToast } from 'modules/layout/layout.actions';
import { getClients } from 'modules/clients/clients.actions';
import { GET_CLIENTS_FAILURE } from 'modules/clients/types';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const SurveyQuestionDetailView = props => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const questionDetails = props.surveyQuestions
    ? props.surveyQuestions.find(sq => sq.surveyQuestion.surveyQuestionId === parseInt(props.match.params.surveyQuestionId))
    : null;
  const variations = props.surveyQuestionVariations ? props.surveyQuestionVariations : null;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const id = props.match.params.surveyQuestionId;

      props.setQuestionId(id);

      await fetchEnumerations(props);

      if (!props.surveyQuestions) {
        let { type } = await props.getSurveyQuestions();
        if (type === GET_SURVEY_QUESTIONS_FAILURE) {
          props.showToast('Failed to retrieve survey questions, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      if (!props.unmappedClients) {
        let { type } = await props.getClients();
        if (type === GET_CLIENTS_FAILURE) {
          props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      setIsLoading(false);
    }

    fetchData();
  }, []);

  const canReadSurveys = hasPermission(Permissions.Admin.Surveys.Read);
  const canEditSurveys = hasPermission(Permissions.Admin.Surveys.Edit);

  if (!canReadSurveys) {
    props.history.push('/');
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!isLoading && questionDetails && props.enumerations.allEnums && props.taggedItems && (
          <Box sx={{ padding: '30px' }}>
            <SurveyQuestionDetails
              surveyQuestionDetails={questionDetails}
              surveyQuestionVariations={variations}
              staticTriggerFields={props.staticTriggerFields}
              taggedItems={props.taggedItems}
              enumerations={props.enumerations.allEnums}
              isReadOnly={!canEditSurveys}
            />
          </Box>
        )}
        {isLoading && <FullscreenSpinner />}
      </Box>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const enumerations = state.enumerations;
  const {
    surveys: { surveyQuestions, surveyQuestionTriggers, surveyQuestionVariations, isLoading, staticTriggerFields, taggedItems },
    clients: { unmappedClients }
  } = state;
  return {
    surveyQuestions,
    surveyQuestionTriggers,
    surveyQuestionVariations,
    isLoading,
    staticTriggerFields,
    taggedItems,
    enumerations,
    unmappedClients
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getSurveyQuestions,
    setSurveyLoadingComplete,
    setQuestionId,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getClients,
    showToast
  })
)(SurveyQuestionDetailView);
